/* eslint-disable no-console */
import { log, supabase } from ".";

export const getOportunidadesBTL = async ({ pais, ano, orderBy = "created_at", ascending = true }) => {
  try {
    const filters = {};
    if (ano) filters.ano = parseInt(ano);

    const data = await supabase.select("sales_btl", {
      filters,
      orderBy,
      ascending,
    });

    return data || [];
  } catch (error) {
    log.error("getOportunidadesBTL", error);
    throw error;
  }
};
